import { getCookieValByName } from './cookies'
import { getValueOfQueryParam } from './query-params'

export function isAEMAuthorMode(): boolean {
	return isAEMMode('edit')
}

function isAEMMode(mode: string): boolean {
	const isLocalPub = globalThis.location.host === 'localhost:4503'
	const isStorybook = globalThis.location.host === 'localhost:6006' || globalThis.location.host === 'localhost:6007'
	const wcmmode = getValueOfQueryParam('wcmmode') || getCookieValByName('wcmmode')

	if (!wcmmode || isLocalPub || isStorybook) {
		return false
	}

	return wcmmode === mode
}
